/**
 * Enums for notifications or confirmations
 */
export enum NotifyOrConfirmType {
	SUCCESS = 'success',
	ERROR = 'error',
	NOTIFICATION = 'notification',
	CONFIRMATION = 'confirmation'
}
